import * as Database from './database.js';
import emptypageImage from '../images/emptypage.gif';
import previewView from './markups.js';
import appView from './appView.js';
import { FAILEDMESSAGE } from '../config.js';

class Timeline extends appView {
  _noteTimeline = document
    .querySelector('#noteTimeline')
    .querySelector('.timeline-line');

  _todoTimeline = document
    .querySelector('#todoTimeline')
    .querySelector('.timeline-line');

  _eventTimeline = document
    .querySelector('#eventTimeline')
    .querySelector('.timeline-line');

  _scrumTimeline = document
    .querySelector('#scrumTimeline')
    .querySelector('.timeline-line');

  _timelineAlert = document.querySelector('.alert-arrow-right');

  constructor() {
    super();

    this.initialize();
  }

  async initialize() {
    await this._LoadTimeline();
    this._loadTodo();
    this._loadEvents();
    this._loadScrum();
    this._loadNotes();
  }

  _emptyPage = function (element) {
    const markup = `
      <div class="empty-image">
        <img
          class="image-none"
          src="${emptypageImage}"
          alt=""
        />
      </div>
  `;
    element.insertAdjacentHTML('beforeend', markup);
  };

  _generateTimelineMarkup = function (data, element) {
    const timeDigits = this.formatTime(data.timestamp);
    const timeAgo = this.relativeTime(data.timestamp);

    const timeFormat = {
      timeDigits,
      timeAgo,
    };
    const markup = previewView.timeLineMarkup(data, timeFormat);

    element.insertAdjacentHTML('beforeend', markup);
  };

  _displayEmptyText(messageEl, message) {
    this._timelineAlert.style.display = 'block';
    messageEl.textContent = message;
  }

  _hideEmptyText(messageEl, message) {
    this._timelineAlert.style.display = 'none';
    messageEl.textContent = message;
  }

  _loadTodo() {
    const self = this;
    $('#pills-todo-tab').on('click', async function (e) {
      e.preventDefault();
      try {
        const emptyText = document
          .getElementById('todoTimeline')
          .querySelector('.empty-text');
        const filterFunction = item => item.completed === 0;
        const data = await Database.getAllItemsFromDatabase(
          'todo',
          filterFunction
        );
        const sortedData = self.sortDataByTimestamp(data);

        const first10Items = sortedData.slice(0, 10);

        if (first10Items.length === 0) {
          self._todoTimeline.innerHTML = '';
          self._displayEmptyText(emptyText, 'Empty Lists');
          self._emptyPage(self._todoTimeline);
        } else {
          self._todoTimeline.innerHTML = '';
          for (const todo of first10Items) {
            const newData = {
              title: todo.title,
              tag: todo.priority,
              timestamp: todo.timestamp,
            };

            self._hideEmptyText(emptyText, 'Get Things Done');
            self._generateTimelineMarkup(newData, self._todoTimeline);
          }
        }
      } catch (err) {
        self.failedMessageInfo(FAILEDMESSAGE);
      }
    });
  }

  _loadNotes() {
    const self = this;
    $('#pills-notes-tab').on('click', async function (e) {
      e.preventDefault();
      await self._LoadTimeline();
    });
  }

  _formatNotesTag(note) {
    let tag;

    if (note === 'note-personal') {
      tag = 'success';
    } else if (note === 'note-work') {
      tag = 'warning';
    } else if (note === 'note-social') {
      tag = 'info';
    } else {
      tag = 'danger';
    }

    return tag;
  }

  async _LoadTimeline() {
    try {
      const emptyText = document
        .getElementById('noteTimeline')
        .querySelector('.empty-text');

      const data = await Database.getAllItemsFromDatabase('notes');
      const sortedData = this.sortDataByTimestamp(data);

      const first10Items = sortedData.slice(0, 10);

      if (first10Items.length === 0) {
        this._noteTimeline.innerHTML = '';
        this._displayEmptyText(emptyText, 'Empty Notes');
        this._emptyPage(this._noteTimeline);
      } else {
        this._noteTimeline.innerHTML = '';
        for (const note of first10Items) {
          const newData = {
            title: note.title,
            tag: this._formatNotesTag(note.tag),
            timestamp: note.timestamp,
          };

          this._hideEmptyText(emptyText, 'Quick Notes');
          this._generateTimelineMarkup(newData, this._noteTimeline);
        }
      }
    } catch (err) {
      this.failedMessageInfo(FAILEDMESSAGE);
    }
  }

  _formatEventsTag(event) {
    let tag;

    if (event === 'Personal') {
      tag = 'success';
    } else if (event === 'Travel') {
      tag = 'warning';
    } else if (event === 'Work') {
      tag = 'primary';
    } else {
      tag = 'danger';
    }

    return tag;
  }

  _loadEvents() {
    const self = this;
    $('#pills-event-tab').on('click', async function (e) {
      e.preventDefault();
      try {
        const emptyText = document
          .getElementById('eventTimeline')
          .querySelector('.empty-text');

        const data = await Database.getAllItemsFromDatabase('event');

        const currentDate = new Date();
        const proximityThreshold = 5 * 24 * 60 * 60 * 1000;

        const filteredData = data.filter(item => {
          const eventStartDate = new Date(item.start);
          const timeDifference =
            eventStartDate.getTime() - currentDate.getTime();
          return timeDifference >= 0 && timeDifference <= proximityThreshold;
        });

        const first10Items = filteredData.slice(0, 10);

        if (first10Items.length === 0) {
          self._eventTimeline.innerHTML = '';
          self._displayEmptyText(emptyText, 'Empty Events');
          self._emptyPage(self._eventTimeline);
        } else {
          self._eventTimeline.innerHTML = '';
          for (const event of first10Items) {
            const newData = {
              title: event.title,
              tag: self._formatEventsTag(event.extendedProps.calendar),
              timestamp: event.timestamp,
              startdate: event.start.split('T')[0],
            };

            self._hideEmptyText(emptyText, 'Upcoming Events');
            self._generateTimelineMarkup(newData, self._eventTimeline);
          }
        }
      } catch (err) {
        self.failedMessageInfo(FAILEDMESSAGE);
      }
    });
  }

  _formatScrumTag(scrum) {
    let tag;

    if (scrum === 's-in-progress') {
      tag = 'success';
    } else if (scrum === 's-new') {
      tag = 'primary';
    } else {
      tag = 'warning';
    }

    return tag;
  }

  _loadScrum() {
    const self = this;
    $('#pills-scrum-tab').on('click', async function (e) {
      e.preventDefault();
      try {
        const emptyText = document
          .getElementById('scrumTimeline')
          .querySelector('.empty-text');
        const data = await Database.getAllItemsFromDatabase('scrumboard');
        const sortedData = self.sortDataByTimestamp(data);

        const first10Items = sortedData.slice(0, 10);

        if (first10Items.length === 0) {
          self._scrumTimeline.innerHTML = '';
          self._displayEmptyText(emptyText, 'Empty Tasks');
          self._emptyPage(self._scrumTimeline);
        } else {
          self._scrumTimeline.innerHTML = '';
          for (const scrum of first10Items) {
            const newData = {
              title: scrum.title,
              tag: self._formatScrumTag(scrum.tasksection),
              timestamp: scrum.timestamp,
            };

            self._hideEmptyText(emptyText, 'Organize Tasks');
            self._generateTimelineMarkup(newData, self._scrumTimeline);
          }
        }
      } catch (err) {
        self.failedMessageInfo(FAILEDMESSAGE);
      }
    });
  }
}

new Timeline();
